<template>
  <div>
    <b-card  title="Atendimento">
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="items"
        :limit="limit"
        :totalRows="totalRows"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import contactService from "@/providers/contactService";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import AppConstants from "@/appConstants";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      totalRows: 0,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "type", label: "Tipo", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por tipo', filterDropdownItems: [] } },
        { field: "email", label: "Email", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por email', trigger: 'enter' } },
        { field: "name", label: "Nome", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome', trigger: 'enter' } },
        { field: "phone", label: "Telefone", sortable: false },
        { field: "comment", label: "Comentário", sortable: false },
        { field: "subjects", label: "Assunto", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por assunto', filterDropdownItems: [] } },
        { field: "origin", label: "Origem", type: "object", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
      ],
      /* eslint-disable global-require */
      items: [],
    };
  },
  mounted() {
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllSubjects(new URLSearchParams()),
      ]).then((res) => {
          const origins = res[0].map(item => {
            return { value: item.id, text: item.name };
          });
          const subjects = res[1].map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
          this.fields[this.fields.findIndex(item => item.field=='subjects')].filterOptions.filterDropdownItems = subjects;
          this.fields[this.fields.findIndex(item => item.field=='type')].filterOptions.filterDropdownItems = AppConstants.CONTACT_TYPE;
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', contactService.getAllContact(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          // console.log(res);
          this.items = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>